import { useContext } from 'react'
import styled from '@emotion/styled'
import { t } from '@lingui/core/macro'
import Typography from '@mui/material/Typography'
import { CvsTextField } from '@components'
import { useIntegrationAssignment } from '@global/hooks'
import { templateCopyContext } from '../../../../context'

const FullWidth = styled.div`
  width: 100%;
`
const NoMarginTypography = styled(Typography)`
  margin-top: 0px;
`
const TypographyBold = styled(Typography)`
  weight: 500;
`
const FullWidthTextField = styled(CvsTextField as any)`
  width: 100%;
  margin-top: 16px;
  margin-bottom: 16px;
`

interface IntegrationTitleProps {
  integrationTitle: string | null
  integrationAssignment: any
}

export const IntegrationTitle = ({
  integrationTitle,
  integrationAssignment,
}: IntegrationTitleProps) => {
  const { onChange } = useContext<any>(templateCopyContext)
  const { onIntegrationChange } = useIntegrationAssignment({ integrationAssignment, onChange })

  return (
    <FullWidth>
      <TypographyBold variant="h4">{t`Integration details`}</TypographyBold>
      <NoMarginTypography variant="body2">
        {t`Enter basic details to describe this integration`}
      </NoMarginTypography>
      <FullWidthTextField
        margin="dense"
        label={t`Integration name`}
        value={integrationTitle}
        onChange={e => {
          onIntegrationChange(e.target.value, 'name')
        }}
      />
    </FullWidth>
  )
}
